import 'twin.macro';
import { LocaleWrapper } from '..';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import tw from 'twin.macro';

import { Title } from '@restworld/ui-ds';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';

import { LayoutWrapper } from '../../../layouts';
import { ViewOtherRestaurantsButton } from './restaurant-job-positions';

export const RestaurantNotFound = () => {
  const { t: showcasePageT } = useTranslation('restaurant-showcase-page');
  return (
    <LayoutWrapper hasFooter hasNavbar title="Locale">
      <LocaleWrapper>
        <div tw="flex flex-col items-center justify-start h-full w-full gap-0">
          <Image
            src={getAssetSrc('/utils-assets/restaurant-not-found.svg')}
            width={238}
            height={220}
            alt={showcasePageT('restaurant_not_found')}
            loader={customImageLoader}
          />
          <div tw="flex flex-col items-center lg:w-[411px] w-full mt-2.5 mb-8 text-center">
            <Title variant="h4-medium" textColor="black" fontWeight="semibold">
              {showcasePageT('we_are_sorry')} 😔
            </Title>
            <Title variant="h4-medium" textColor="black" fontWeight="semibold">
              {showcasePageT('cant_find_restaurant')}.
            </Title>
            <Title twStyle={tw`mt-4`} variant="h6-large" textColor="gray-500" fontWeight="normal">
              {showcasePageT('plenty_of_offer')}!
            </Title>
          </div>
          <div tw="lg:w-[325px] w-full">
            {' '}
            <ViewOtherRestaurantsButton />
          </div>
        </div>
      </LocaleWrapper>
    </LayoutWrapper>
  );
};
